<template>
    <div>
        <div class="level">
            <div class="level-left">
                <h3 class="is-size-5">{{ headline }}</h3>
            </div>
        </div>
        <div class="columns">
            <div class="column">
                <label class="checkbox">
                    <input type="checkbox" v-model="filters.onlyDirectCases">
                    Vis kun direkte sager
                </label>
            </div>
        </div>

        <div class="columns" style="padding-bottom: 150px;">

            <div class="column is-2">
                <aside class="menu">
                    <p class="menu-label">
                        Vælg årstal
                    </p>
                    <ul class="menu-list" v-for="projectYear in projectYearsInOrder" :key="projectYear">
                        <li>
                            <a @click.prevent="onYearSelect(projectYear)"
                               :class="{ 'is-active': selectedYear == projectYear }"
                               style="display: flex; justify-content: space-between">
                                {{ projectYear }}
                                <span class="tag" style="background-color: #eee">{{
                                        countProjectByYear(projectYear)
                                    }}</span>
                            </a>
                        </li>
                    </ul>
                </aside>
            </div>
            <div class="column">
                <list
                    table-classes="table is-fullwidth"
                    :columns="columns"
                    :data="projectListForSelectedYear"
                    :display-header="true"
                    :page-length="10"
                    :default-order="{col:  'status', dir: 'asc'}"
                    :enableSearchBoxRowsThreshold="0"
                    :scroll-to-top="false"
                    :default-page="selectedPage"
                    @pageChanged="onPageChanged"
                >
                    <slot slot-scope="{ item }">
                        <tr
                            @click.stop="$router.push({ name: 'project.edit', params: { id: item.id }})"
                            class="pointer"
                            :class="{
                            'remove-bottom-border': collapsed[item.id] || false,
                            'is-danger': item.is_overdue
                        }"
                            :title="item.description"
                        >
                            <td>
                                <i
                                    class="fa fa-w16"
                                    :class="{
                                'fa-chevron-down': collapsed[item.id] || false,
                                'fa-chevron-right': !collapsed[item.id] || false,
                            }"
                                    @click.stop="toggleCollapse(item)"
                                />
                                #{{ item.id }}
                            </td>
                            <td>
                                {{ item.created_at_display | humanDate }}
                            </td>
                            <td class="overflow-dots">{{ item.customer ? item.customer.name : '-' }}</td>
                            <td>{{ item.display_status.name }}</td>
                            <td class="overflow-dots">{{ item.location_id !== -1 ? item.location ? item.location.name : '-' : 'Ekstern' }}</td>
                            <td>{{ item.user ? item.user.initials : '-' }}</td>
                            <td class="overflow-dots">
                                {{ item.description }}
                            </td>
                        </tr>
                        <tr v-if="collapsed[item.id] && item.reports !== undefined">
                            <td colspan="5">
                                <div
                                    v-for="report in item.reports"
                                    :key="'report-'+report.id"
                                    :class="['report', 'report--' + (report.closed_at !== null ? 'closed' : 'open') ]"
                                    @click.stop="$router.push({ name: 'project.reports.edit', params: {
                                id: report.project_id,
                                reportid: report.id
                            }})"
                                >
                                    {{ item.id }}-{{ report.id }} Servicerapport
                                    ({{ findUser(report.user_id) ? findUser(report.user_id).name : '' }})
                                </div>

                                <div class="report" @click.stop="createServiceRapport(item.id)"
                                     v-if="item.status === 0">
                                    <span class="is-size-7" style="padding-left:10px">Opret servicerapport</span>
                                </div>
                            </td>
                        </tr>
                    </slot>
                </list>
            </div>
        </div>
    </div>
</template>

<script>
import List from '@elems/list'
import moment from 'moment';
import cloneDeep from "lodash/cloneDeep";
import groupBy from "lodash/groupBy";
import humanDate from "../../filters/humanDate";

export default {
    components: {
        List,
    },
    filters: {
        humanDate,
    },
    props: {
        headline: String,
        projects: Array,
        customer: Object,
    },
    data() {
        return {
            columns: [
                { name: 'id', title: 'Sagsnr.', sortable: true, searchable: true, width: '100px' },
                { name: 'created_at_display', title: 'Dato', sortable: true, searchable: true, width: '120px' },
                { name: 'customer', title: 'Kunde', sortable: true, searchable: true, width: '200px' },
                { name: 'display_status', title: 'Status', sortable: true, searchable: true, width: '100px' },
                { name: 'location', title: 'Lokation', sortable: true, searchable: true, width: '130px' },
                { name: 'user', title: 'ID', sortable: true, searchable: true, width: '50px' },
                { name: 'description', title: 'Beskrivelse', sortable: false, searchable: true },
                { name: 'status', hidden: true },
            ],
            collapsed: {},
            selectedYear: null,
            selectedPage: 1,
            filters: {
                onlyDirectCases: false,
            }
        }
    },
    created() {
        this.syncQueryWithState();
    },
    computed: {
        projectListForSelectedYear() {
            if (this.selectedYear) {
                return this.groupedProjectsByYear[this.selectedYear] || [];
            }
            return [];
        },
        listProjects() {
            return cloneDeep(this.projects)
                .map(item => {
                    item.created_at_display = item.created_at;

                    item.year = moment(item.created_at).format('YYYY');

                    return item
                });
        },
        filteredProjects() {
            return this.listProjects.filter(project => {
                if (this.filters.onlyDirectCases) {
                    return project.customer_id === this.customer.id
                }
                return true;
            });
        },
        groupedProjectsByYear() {
            return groupBy(this.filteredProjects, 'year');
        },
        projectYearsInOrder() {
            return Object.keys(this.groupedProjectsByYear).slice().reverse()
        },
    },
    methods: {
        onYearSelect(year) {
            this.selectedPage = 1;
            this.selectedYear = year;
            this.setQueryFilterOnStateChange();
        },
        onPageChanged(page) {
            this.selectedPage = page;
            this.setQueryFilterOnStateChange();
        },
        findUser(userId) {
            return this.$store.getters.findUser(userId)
        },
        toggleCollapse(item) {
            this.$set(this.collapsed, item.id, !this.collapsed[item.id])
        },
        createServiceRapport(projectId) {
            window.axios.post('/api/reports', { project_id: projectId })
                .then(({ data }) => {
                    this.$store.dispatch('addReport', data)
                    this.$router.push({
                        name: 'project.reports.edit', params: {
                            id: projectId,
                            reportid: data.id
                        }
                    })
                    this.$store.dispatch('setSuccess', 'Servicerapporten blev oprettet')
                })
                .catch(error => {
                })
        },
        countProjectByYear(year) {
            const projects = this.groupedProjectsByYear[year] || [];
            return projects.length;
        },
        resetSelectedYear() {
            if (this.projectYearsInOrder.length > 0) {
                [this.selectedYear] = this.projectYearsInOrder;
            }
        },
        setQueryFilterOnStateChange() {
            const query = { ...this.$route.query };
            query.year = this.selectedYear;
            query.directCases = this.filters.onlyDirectCases;
            if (this.selectedPage > 1) {
                query.page = this.selectedPage;
            } else {
                delete query.page;
            }
            this.$router.replace({ query });
        },
        syncQueryWithState() {
            const { year, directCases, page } = this.$route.query;

            if (year) {
                this.selectedYear = year;
            } else {
                this.resetSelectedYear();
            }
            if (directCases) {
                this.filters.onlyDirectCases = directCases === 'true';
            }
            
            if (page > 1) {
                this.selectedPage = parseInt(page);
            }
        }
    },
    watch: {
        projects() {
            this.syncQueryWithState();
        },
        'filters.onlyDirectCases'() {
            this.selectedPage = 1;

            if (this.projectListForSelectedYear.length === 0) {
                this.resetSelectedYear();
            }

            this.setQueryFilterOnStateChange();
        },
    },
}
</script>
